<template>
  <div class="bfsp-box">
  	<video :src="url" controls></video>
  </div>
</template>

<script>
export default {
  data() {
    return {
	  url:this.$route.query.url
    };
  },
  mounted() {
	
  },
  methods: {
	

  }
};
</script>
<style scoped lang="scss">
	.bfsp-box{
		background: #161823;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>


// WEBPACK FOOTER //
// bofangshipin.vue?95a07a86